import { format } from 'date-fns'

class Feedback {
    constructor(props){
        let updatedProps = props || {}
        this.feedbackID = updatedProps.feedbackID
        this.userID = updatedProps.userID;
        this.date = updatedProps.date && format(new Date(updatedProps.date), 'LLL d Y') || format(new Date(), 'LLL d Y');
        this.value = updatedProps.value
    }
}

export default Feedback
